import {RecordKind} from 'core/Record';
import {UpdatersRegistry} from '../types';
import {deleteIncome} from './income';
import {deleteRefill} from './refill';
import {deleteSpend} from './spend';

export const budgetUpdaters: UpdatersRegistry = {
  [RecordKind.Refill]: deleteRefill,
  [RecordKind.Income]: deleteIncome,
  [RecordKind.Spend]: deleteSpend,
};
